import { useState } from "react";
import { addContactToTheList } from "@/services/mailingListService";
import { useForm as useReactHookForm, useFormState } from "react-hook-form";
import { useForm } from "@formcarry/react";
import { useScrollToTop } from "@/hooks/useScrollToTop";

export const useFormHandler = (id: string) => {
  const { state, submit } = useForm({ id });
  const {
    register,
    formState: { errors },
    control,
    getValues,
  } = useReactHookForm({ mode: "all" });

  useScrollToTop([state.submitted, state.error]);

  const { isValid } = useFormState({ control });
  const [isMailingListSubscriber, setMailingListSubscriber] = useState(false);
  const [isRecaptcha, setRecaptcha] = useState(false);

  const handleCaptchaChange = () => {
    setRecaptcha(!isRecaptcha);
  };

  const handleMailingListChange = () => {
    setMailingListSubscriber(!isMailingListSubscriber);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    isMailingListSubscriber && addContactToTheList(getValues("email"));
    submit(event);
  };

  return {
    isValid,
    errors,
    isRecaptcha,
    state,
    register,
    handleCaptchaChange,
    handleMailingListChange,
    handleFormSubmit,
    control,
  };
};
